var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _path9, _path0, _path1, _path10, _path11, _path12, _ellipse9, _ellipse0, _ellipse1, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumerPromo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 1400,
    viewBox: "0 0 1400 1400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M632.045 551.971C593.533 438.703 509.708 191.777 715.294 212.166C798.543 220.422 859.711 331.098 897.089 501",
    stroke: "white",
    strokeWidth: 23.7864,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M526.7 526.486C503.48 428.508 490.341 227.796 623.545 208.767C756.749 189.738 800.243 374.139 805.34 468.719",
    stroke: "white",
    strokeWidth: 23.7864,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.243 424.544L722.088 480.612",
    stroke: "white",
    strokeWidth: 23.7864,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.34 907.068L392.476 922.359",
    stroke: "white",
    strokeWidth: 10.1942,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.941 964.835L231.068 1044.69L419.66 1049.79",
    stroke: "white",
    strokeWidth: 20.3883,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M417.961 1150.03L637.136 1240.08L1226.7 1065.08",
    stroke: "white",
    strokeWidth: 20.3883,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.941 966.534L215.776 890.078",
    stroke: "white",
    strokeWidth: 20.3883,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M420.513 1150.25L545.389 1019.2",
    stroke: "white",
    strokeWidth: 13.5922,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.286,
    cy: 282.179,
    rx: 5.11136,
    ry: 18.8191,
    transform: "rotate(2.75974 147.286 282.179)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.398,
    cy: 328.87,
    rx: 5.11136,
    ry: 18.8191,
    transform: "rotate(2.75974 145.398 328.87)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.682,
    cy: 305.368,
    rx: 5.11136,
    ry: 14.3174,
    transform: "rotate(92.7597 126.682 305.368)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.55,
    cy: 306.792,
    rx: 5.11136,
    ry: 14.3174,
    transform: "rotate(92.7597 165.55 306.792)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1326.18,
    cy: 465.263,
    rx: 4.08901,
    ry: 15.055,
    transform: "rotate(2.75974 1326.18 465.263)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1324.67,
    cy: 502.616,
    rx: 4.08901,
    ry: 15.055,
    transform: "rotate(2.75974 1324.67 502.616)",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1309.7,
    cy: 483.814,
    rx: 4.08901,
    ry: 11.4537,
    transform: "rotate(92.7597 1309.7 483.814)",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1340.79,
    cy: 484.953,
    rx: 4.08901,
    ry: 11.4537,
    transform: "rotate(92.7597 1340.79 484.953)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1844,
    cy: 834.01,
    r: 10.1942,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9903,
    cy: 915.563,
    r: 16.9903,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.457,
    cy: 1167.02,
    r: 20.3883,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 965.049,
    cy: 218.961,
    r: 20.3883,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.505,
    cy: 1126.24,
    r: 10.1942,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1036.41,
    cy: 161.194,
    r: 10.1942,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1077.18,
    cy: 290.32,
    r: 10.1942,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369.42,
    cy: 653.913,
    r: 10.1942,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1389.81,
    cy: 864.592,
    r: 10.1942,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 1362.62,
    cy: 752.456,
    r: 6.79612,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 1352.43,
    cy: 918.961,
    r: 6.79612,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.486,
    cy: 1112.65,
    r: 6.79612,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.816,
    cy: 1214.59,
    r: 6.79612,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.388,
    cy: 1241.78,
    r: 6.79612,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.3694,
    cy: 874.786,
    r: 6.79612,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.641 964.835L271.934 422.845",
    stroke: "white",
    strokeWidth: 20.3883,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M233.508 1045.2L326.214 434.738",
    stroke: "white",
    strokeWidth: 20.3883,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M637.135 1228.18L498.68 531.58",
    stroke: "white",
    strokeWidth: 20.3883,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M446.838 541.778L1016.02 436.437",
    stroke: "white",
    strokeWidth: 20.3883,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M417.96 1150.03L444.681 545.175",
    stroke: "white",
    strokeWidth: 20.3883,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.8 1061.68L1017.28 439.835",
    stroke: "white",
    strokeWidth: 20.3883,
    strokeLinecap: "round"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.679,
    cy: 495.903,
    rx: 28.8835,
    ry: 25.4854,
    fill: "white"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 637.136,
    cy: 563.864,
    rx: 28.8835,
    ry: 25.4854,
    transform: "rotate(-13.201 637.136 563.864)",
    fill: "white"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 900.445,
    cy: 512.02,
    rx: 28.8835,
    ry: 25.4854,
    transform: "rotate(-13.201 900.445 512.02)",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M385.68 490.806C391.343 399.625 460.777 213.864 598.058 213.864",
    stroke: "white",
    strokeWidth: 23.7864,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.47 579.817C1198.88 576.34 1213.39 585.14 1216.97 599.523L1241.29 697.237C1241.27 697.24 1241.26 697.244 1241.24 697.248C1225.77 701.1 1216.34 716.771 1220.19 732.25C1224.04 747.73 1239.71 757.156 1255.19 753.305C1255.21 753.302 1255.22 753.297 1255.23 753.293L1281.08 857.175C1284.69 871.652 1275.85 886.303 1261.37 889.875L763.606 1012.65C749.185 1016.2 734.603 1007.43 730.987 993.028L705.164 890.156C720.253 886.03 729.36 870.586 725.563 855.326C721.756 840.027 706.406 830.642 691.104 834.142L665.717 733.007C662.068 718.466 670.978 703.738 685.551 700.221L1184.47 579.817ZM760.271 931.144L756.975 931.971L763.332 957.291C766.951 971.706 781.544 980.482 795.973 976.922L816.642 971.823L815.829 968.524L815.015 965.224L794.345 970.323C783.549 972.986 772.632 966.42 769.924 955.635L763.567 930.316L760.271 931.144ZM856.354 955.026L857.168 958.326L857.982 961.623L899.321 951.425L898.507 948.127L897.693 944.828L856.354 955.026ZM939.033 934.629L940.66 941.227L981.999 931.029L981.185 927.73L980.372 924.43L939.033 934.629ZM1021.71 914.232L1022.52 917.532L1023.34 920.831L1064.68 910.631L1063.86 907.333L1063.05 904.034L1021.71 914.232ZM1104.39 893.835L1105.2 897.134L1106.02 900.433L1147.36 890.235L1146.54 886.936L1145.73 883.637L1104.39 893.835ZM999.359 724.69L941.66 882.354L960.241 877.581L1017.94 719.916L999.359 724.69ZM734.843 829.868L731.547 830.696L744.261 881.332L747.557 880.506L750.853 879.678L738.139 829.04L734.843 829.868ZM1216.25 818.774L1222.49 843.859L1222.61 844.367C1224.98 855.037 1218.41 865.705 1207.73 868.338L1187.07 873.438L1187.88 876.738L1188.69 880.037L1209.36 874.938C1223.85 871.363 1232.69 856.703 1229.09 842.218L1222.85 817.133L1216.25 818.774ZM1034.52 795.03C1029.07 793.361 1022.87 793.418 1015.94 795.2C1009.18 796.937 1003.82 799.871 999.857 804.003C995.897 808.136 993.29 812.921 992.037 818.358C990.827 823.783 990.949 829.332 992.406 835.002L994.221 842.069C995.678 847.739 998.222 852.665 1001.85 856.847C1005.53 861.018 1010.1 863.959 1015.56 865.671C1021.02 867.384 1027.18 867.359 1034.02 865.6C1040.87 863.841 1046.3 860.889 1050.3 856.746C1054.31 852.602 1056.91 847.817 1058.12 842.391C1059.38 836.954 1059.27 831.401 1057.82 825.731L1056 818.665C1054.52 812.907 1051.95 807.943 1048.27 803.772C1044.6 799.601 1040.01 796.687 1034.52 795.03ZM1021.18 815.613C1024.93 814.649 1027.67 815.249 1029.39 817.412C1031.1 819.574 1032.3 821.963 1032.97 824.581L1034.79 831.647C1035.46 834.264 1035.51 836.902 1034.94 839.56C1034.41 842.207 1032.33 843.995 1028.71 844.925C1025.27 845.81 1022.6 845.216 1020.72 843.142C1018.87 841.013 1017.63 838.705 1016.99 836.219L1015.18 829.153C1014.5 826.536 1014.46 823.849 1015.06 821.092C1015.69 818.325 1017.74 816.498 1021.18 815.613ZM944.678 736.366C939.228 734.697 933.035 734.754 926.099 736.536C919.426 738.25 914.104 741.152 910.132 745.241C906.161 749.33 903.526 754.098 902.229 759.546C900.975 764.983 901.088 770.581 902.567 776.338L904.382 783.405C905.839 789.075 908.378 793.979 911.999 798.118C915.663 802.245 920.22 805.142 925.67 806.811C931.121 808.48 937.27 808.434 944.118 806.675C950.966 804.916 956.403 802.008 960.429 797.952C964.455 793.895 967.079 789.175 968.3 783.793C969.565 778.4 969.458 772.825 967.979 767.067L966.164 760C964.684 754.243 962.107 749.278 958.432 745.108C954.757 740.937 950.172 738.023 944.678 736.366ZM931.343 756.95C935.094 755.986 937.829 756.585 939.547 758.748C941.265 760.91 942.461 763.3 943.133 765.917L944.949 772.984C945.621 775.601 945.671 778.238 945.098 780.896C944.569 783.543 942.494 785.331 938.874 786.261C935.559 787.113 932.988 786.518 931.162 784.476C929.335 782.434 928.086 780.105 927.414 777.488L925.598 770.422C924.959 767.936 924.888 765.303 925.383 762.526C925.911 759.694 927.898 757.835 931.343 756.95ZM732.314 721.931C717.735 725.454 708.824 740.191 712.476 754.739L718.834 780.057L722.129 779.229L725.424 778.402L719.069 753.082C716.337 742.198 723.003 731.174 733.912 728.538L754.627 723.531L753.829 720.229L753.031 716.925L732.314 721.931ZM1191.29 718.432L1203.77 768.603L1210.37 766.962L1197.89 716.791L1191.29 718.432ZM794.462 706.914L795.261 710.217L796.058 713.52L837.491 703.508L836.693 700.207L835.895 696.903L794.462 706.914ZM877.327 686.891L878.126 690.195L878.922 693.498L920.355 683.486L919.557 680.184L918.759 676.88L877.327 686.891ZM960.191 666.869L960.99 670.171L961.787 673.475L1003.22 663.463L1002.42 660.16L1001.62 656.858L960.191 666.869ZM1179.17 641.536C1175.58 627.14 1161.05 618.333 1146.64 621.817L1125.92 626.824L1126.72 630.126L1127.52 633.429L1148.23 628.424C1159.02 625.818 1169.89 632.406 1172.57 643.176L1178.81 668.261L1185.41 666.621L1179.17 641.536ZM1043.06 646.846L1043.85 650.149L1044.65 653.453L1086.08 643.441L1085.29 640.137L1084.49 636.834L1043.06 646.846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerPromo);
export default __webpack_public_path__ + "static/media/consumer-promo.521f02bfbf73e9337647e919f793ff10.svg";
export { ForwardRef as ReactComponent };